/**
 * Lead-submit success event bus (v5.5).
 *
 * Why: the Review CTA must only render on real lead-submit success
 * screens (Build My Deal, Find Me a Vehicle, Contact, Trade, Test
 * Drive). LeadForm dispatches `ssc:lead-submitted` on success, and the
 * gated <LeadSuccessReviewCta/> mounts on that event and persists a
 * session flag so the user is asked at most once per visit.
 */

const EVENT = "ssc:lead-submitted";
const SESSION_DISMISS_KEY = "ssc_review_cta_dismissed_v1";

export function dispatchLeadSubmitted(detail) {
  try {
    window.dispatchEvent(new CustomEvent(EVENT, { detail: detail || {} }));
  } catch {}
}

export function onLeadSubmitted(handler) {
  const wrap = (e) => handler(e.detail || {});
  window.addEventListener(EVENT, wrap);
  return () => window.removeEventListener(EVENT, wrap);
}

export function markReviewCtaDismissed() {
  try {
    sessionStorage.setItem(SESSION_DISMISS_KEY, "1");
  } catch {}
}

export function wasReviewCtaDismissed() {
  try {
    return sessionStorage.getItem(SESSION_DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}
